module.exports = __webpack_public_path__ + "img/sanbao-jiaonang.e09b4dec.png";